import { hooks } from "botframework-webchat";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";


import { ModalType } from "../../../constants/enums";
import { openOrCloseModal } from "../../../store/modalActionsSlice";
import iconUser from "../../../Assets/chat/UserAvatar.png";
import iconBot from "../../../Assets/chat/BotAvatar.png";
import iconLike from "../../../Assets/chat/like.png";
import iconDislike from "../../../Assets/chat/dislike.png";
import {
  getFeedbackHistory,
  History,
  storeFeedback,
} from "./createFeedbackHistory";
import { toast } from "react-toastify";
import React from "react";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BotActivityDecorator = ({ activityID, text,activity, children }: any) => {
 console.log("text ", text);
  const [actionStatus, setActionStatus] = useState("Idle");
  const [delayDuration, setDelayDuration] = useState(5000);
  const { usePostActivity, useSetNotification, useDismissNotification } = hooks;
  const [showFormFeedback, setShowFormFeedback] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [feedback, setFeedback] = useState<string>("");
  const dispatch = useDispatch();
  const notification = useSetNotification();
  const dismissNotification = useDismissNotification();
  const [feedbackWasSent, setFeedbackWasSent] = useState<boolean>(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState<string | undefined>();
  const postActivity = usePostActivity();
  let itemsFeedbackHistory = getFeedbackHistory();

  const handleUpvoteButton = useCallback(() => {
    postActivity({
      type: "messageReaction",
      activityID: activityID,
      reactionsAdded: [{ id: activityID, type: "like" }],
    } as any);
  }, [activityID, postActivity]);

  const handleDownvoteButton = useCallback(() => {
    localStorage.setItem("activityId", activityID);
    setShowForm(true);
    // dispatch(openOrCloseModal({ isOpen: true, modalType: ModalType.Feedback }));
  }, [activityID, postActivity]);

  const showReactions = () => {
    const message = itemsFeedbackHistory.find(
      (history: History) => history.messageId === activityID
    );
    if (message) {
      if (message.reactionType === "like") return false;
      if (message.feedbackId !== "") return false;
    }
    return true;
  };

  const showFeedback = () => {
    setShowFormFeedback(!showFormFeedback);
  };

  const copyTextToClipboard = useCallback(() => {
    notification({
      id: "Tet",
      level: "info",
      alt: "Copied",
      message: "Copied",
    });
    setActionStatus("Action in progress...");

    // Use setTimeout to simulate a delayed action
    setTimeout(() => {
      dismissNotification("Tet");
      setActionStatus("Action completed!");
    }, delayDuration);

    if (text) {
      navigator.clipboard.writeText(text.replace(/(<([^>]+)>)/gi, ""));

      const tooltip = document.getElementById("myTooltip");
      if (tooltip) tooltip.innerHTML = "Copied";
    }
  }, [text]);

  const onFeedbackChange = (value: string) => {
    setFeedback(value);
  };

  const sendFeedback = async () => {
    // setIsLoading(true)
    setShowForm(false);
    const activityId = localStorage.getItem("activityId");
    const conversationId = activityId?.split("|")[0];

    postActivity({
      type: "messageReaction",
      activityID: activityId,
      reactionsAdded: [{ id: activityId, type: "dislike" }],
    } as any);

    const token: any = localStorage.getItem("newToken");
    const tokenData = JSON.parse(token);
    const response = await fetch(
      `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "message",
          from: {
            id: localStorage.getItem("fromid"),
          },
          value: {
            action: "send_feedback_to_bot",
            message: "Feedback from Dislike!",
            feedback: feedback,
          },
        }),
      }
    );

    if (!response.ok) {
      // setIsLoading(false)
      await dispatchToast(
        `Direct Line token API call failed with status ${response.status}`,
        "error"
      );
      throw new Error(
        `Direct Line token API call failed with status ${response.status}`
      );
    }

    const responseJson = await response.json();
    storeFeedback(activityId || "", responseJson.id);

    // setIsLoading(false)
    // dispatch(showModalHeader(false))
    setFeedbackWasSent(true);
    setTimeout(() => {
      dispatch(
        openOrCloseModal({ isOpen: false, modalType: ModalType.Feedback })
      );
      // dispatch(showModalHeader(true))
    }, 4000);
  };

  const dispatchToast = async (text: string, type: any) =>
    toast(text, {
      theme: "colored",
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      position: "bottom-left",
      autoClose: 5000,
      type,
    });

  const cancelFeedback = () => {
    setShowForm(false);
    setShowFormFeedback(false);
    setFeedbackWasSent(false);
    setFeedback("");
  };
  const FullScreenImageModal = ({
    src,
    onClose
  }: {
    src: string;
    onClose: () => void;
  }) => {
    return (
      <div className="fullscreen-overlay" onClick={onClose}>
        <img src={src} className="fullscreen-image" />
        <span className="close-icon" onClick={onClose}>✕</span>
      </div>
    );
  };
  
  function exportHtmlTableToCSV(containerId: string, filename: string) {
    const container = document.getElementById(containerId);
    if (!container) return;
  
    const table = container.querySelector("table");
    if (!table) return;
  
    let csv = "";
    for (const row of Array.from(table.rows)) {
      const rowData: string[] = [];
      for (const cell of Array.from(row.cells)) {
        // Escapa comas, dobles comillas y saltos de línea
        let cellText = cell.textContent?.trim().replace(/"/g, '""') || '';
        rowData.push(`"${cellText}"`);
      }
      csv += rowData.join(",") + "\n";
    }
  
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.csv`;
    link.click();
  }
  
  
  
  return (
    <div className="botActivityDecorator">
      <div className="botActivityDecorator__content">
        <div className="custom-message-container bot-message">
          <img src={iconBot} alt="" className="avatar-image" />
          <div className="w-75">
            {/* <p className="avatar-tag">Bot</p> */}
            <div className="bot-custom-bubble p-2">
            {/* Render texto si existe */}
            {text && text.split('\n').map((line: any, index: any) => {
              const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
              return (
                <p
                  className="p-0 pb-1 m-0"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: formattedLine }}
                ></p>
              );
            })}

              {/* Render attachments si existen */}
              {Array.isArray(activity?.attachments) &&
                activity.attachments.map((attachment: any, index: number) => {
                  // Soporte para imágenes
                  if (attachment.contentType.startsWith("image/")) {
                    return (
                      <div className="image-wrapper" key={index}>
                        <img src={attachment.contentUrl} alt="Respuesta del bot" className="chat-image" />
                        <div
                          className="overlay-icon"
                          onClick={() => {
                            setActiveImage(attachment.contentUrl);
                            setShowImageModal(true);
                          }}
                          title="Full screen"
                        >
                          🔍
                        </div>
                      </div>
                    );
                  }

                  if (
                    attachment.contentType === "application/vnd.microsoft.card.adaptive" &&
                    attachment.content?.body?.[0]?.type === "TextBlock"
                  ) {
                    return (
                      <div key={index} className="table-wrapper">
                      <div
                        id={`table-container-${activity.id}-${index}`}
                        dangerouslySetInnerHTML={{ __html: attachment.content.body[0].text }}
                      />
                        <button
                          className="btn btn-sm btn-outline-info download-btn"
                          onClick={() =>
                            exportHtmlTableToCSV(`table-container-${activity.id}-${index}`, `bot-table-${activity.id}`)
                          }
                        >
                          <FontAwesomeIcon icon={faDownload} size="lg" />
                        </button>

                    </div>

                    );
                  }

                  return null;
                })}
              
              
            </div>





            {showForm && (
              <div
                className="feedback p-2 mt-2"
                style={{
                  display: feedbackWasSent ? "none" : "block",
                  width: "100%",
                }}
              >
                <h4 className="feedback-title m-2">
                  We ask you to provide feedback to AI Agent.
                </h4>
                {showFormFeedback && (
                  <div className="feedback-textarea-container p-2">
                    <label htmlFor="feedback">Feedback</label>
                    <textarea
                      id="feedback-area"
                      placeholder=" "
                      required
                      onChange={(e) => onFeedbackChange(e.target.value)}
                    ></textarea>
                  </div>
                )}
                <div className="d-flex m-2">
                  {!showFormFeedback && (
                    <button className="feedback-btn" onClick={showFeedback}>
                      Provide Feedback
                    </button>
                  )}
                  {showFormFeedback && (
                    <>
                      <button
                        className="feedback-btn mr-1"
                        onClick={() => sendFeedback()}
                      >
                        Provide Feedback
                      </button>
                      <button
                        className="feedback-btn ms-2"
                        onClick={() => cancelFeedback()}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}

          {showImageModal && activeImage && (
            <FullScreenImageModal
              src={activeImage}
              onClose={() => {
                setShowImageModal(false);
                setActiveImage(undefined);
              }}
            />
          )}
          </div>
        </div>
      </div>
      <div className="reaction-buttons-container">
        {showReactions() && (
          <>
            <button
              className="botActivityDecorator__button reaction-buttons"
              onClick={handleUpvoteButton}
            >
              <img src={iconLike} />
            </button>
            <button
              className="botActivityDecorator__button reaction-buttons"
              onClick={handleDownvoteButton}
            >
              <img src={iconDislike} />
            </button>
          </>
        )}

        {/* <div className="tooltip">
          <button
            className="botActivityDecorator__button reaction-buttons"
            onClick={copyTextToClipboard}
          >
            <span
              className="tooltiptext"
              id="myTooltip"
              style={{ marginLeft: showReactions() ? "-20px" : "-15px" }}
            >
              Copy to clipboard
            </span>
            <img src="static/images/icons/Copy.png" />
          </button>
        </div> */}
        <i className="ai-text text-white w-75">
        Please note that AI-generated content
        should be verified independently
        </i>
      </div>
    </div>
  );
};
const BotActivity = ({ text, children }: any) => {
  return (
    <div className="botActivityDecorator">
      <div className="botActivityDecorator__content">
        <div className="custom-message-container bot-message">
          <img src={iconBot} alt="" className="avatar-image" />
          <div className="w-75">
            {/* <p className="avatar-tag">Bot</p> */}
            <div className="bot-custom-bubble">
              <p>{children}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserActivityDecorator = ({ activityID, text, children }: any) => {
  return (
    <>
      <div className="custom-message-container">
        <img src={iconUser} alt="User Avatar" className="avatar-image" />
        <div className="w-50">
          <div className="user-custom-bubble">
            <p className="avatar-tag"></p>
            <p>{text}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const activityMiddleware =
  () =>
  (next: any) =>
  (...setupArgs: any) => {
    const [card] = setupArgs;

    const activity = card.activity;
    const id = activity?.id;

    if (!activity) return next(...setupArgs);

    // Mensaje del usuario
    if (activity.from.role === "user") {
      if (activity.type === "message") {
        activity.activityID = id;

        localStorage.setItem("clientActivityID", activity.channelData?.clientActivityID || "");
        localStorage.setItem("fromid", activity.from.id);

        return (...renderArgs: any) => (
          <UserActivityDecorator
            activityID={activity.id}
            key={activity.id}
            text={activity.text}
          >
            {next(card)(...renderArgs)}
          </UserActivityDecorator>
        );
      }
    }

    // Mensaje del bot
    if (activity.from.role === "bot") {
      // Guardar feedback ID
      if (activity.id && card.nextVisibleActivity?.id) {
        storeFeedback(activity.id, card.nextVisibleActivity.id);
      }

      // No renderizar feedback automático
      const nextAttachment = card.nextVisibleActivity?.attachments?.[0]?.content?.actions?.[0]?.title;
      const thisAttachment = activity.attachments?.[0]?.content?.actions?.[0]?.title;

      if (nextAttachment === "Provide feedback" || thisAttachment === "Provide feedback") {
        return;
      }

      // Renderizar actividad decorada si es reaccionable y tiene texto o attachments
      if (
        activity.type === "message" &&
        activity.channelData?.isReactionable === "Yes" &&
        (activity.text || activity.attachments?.length)
      ) {
        return (...renderArgs: any) => (
          <BotActivityDecorator
            activityID={activity.id}
            key={activity.id}
            text={activity.text ?? ''}
            activity={activity}
          >
            {next(card)(...renderArgs)}
          </BotActivityDecorator>
        );
      }

      // Si no cumple condiciones, renderiza normalmente
      return next(...setupArgs);
    }

    // Si no es ni de usuario ni del bot
    return next(...setupArgs);
  };


export default activityMiddleware;
